import React, { useContext } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useUi } from "@jelly/lesson";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";
import { AccordionContext } from "@src/lms/jelly/extensions/ui/accordion/AccordionContext";

import { messages } from "./Preparations.messages";
import styles from "./Preparations.module.scss";

import { HardwareRequirements } from "./components/HardwareRequirements";
import { SoftwareRequirements } from "./components/SoftwareRequirements";

interface Preparations {
  title: string;
}

export const Preparations: React.FC<Preparations> = ({ title }) => {
  return (
    <Accordion allowMultiOpen={false} defaultOpen={["hardware"]}>
      <PreparationsContent title={title} />
    </Accordion>
  );
};

const PreparationsContent: React.FC<Preparations> = ({ title }) => {
  const ui = useUi();
  const { formatMessage } = useIntl();
  const context = useContext(AccordionContext);

  const accordion = (
    <div className={styles.accordion}>
      <ui.Scrollbars>
        <p className={styles.description}>{formatMessage(messages.description)}</p>
        <AccordionItem id={"hardware"} title={formatMessage(messages.accordionItem1Title)} unmountChildrenWhenHidden>
          <p>{formatMessage(messages.accordionItem1Description)}</p>
        </AccordionItem>
        <AccordionItem id={"software"} title={formatMessage(messages.accordionItem2Title)} unmountChildrenWhenHidden>
          <p>{formatMessage(messages.accordionItem2Description)}</p>
        </AccordionItem>
      </ui.Scrollbars>
    </div>
  );

  const renderRightComponent = (): React.ReactNode => {
    if (context.openIds.includes("hardware")) {
      return <HardwareRequirements />;
    }
    if (context.openIds.includes("software")) {
      return <SoftwareRequirements />;
    }
    return null;
  };

  return (
    <StandardCase title={title} leftComponent={accordion}>
      <div className={styles.diagramWrapper}>{renderRightComponent()}</div>
    </StandardCase>
  );
};
